import * as THREE from "three";

export const GlobalUniforms = {
  uCurveX: { value: 0 }
};

export class SceneManager
{
  static scene: THREE.Scene;
  static world: THREE.Group;
  static camera: THREE.PerspectiveCamera;

  static init()
  {
    this.scene = new THREE.Scene();
    this.scene.background = this.createLobbySkyGradient();

    this.world = new THREE.Group();
    this.scene.add( this.world );

    return this.scene;
  }

  private static createLobbySkyGradient(): THREE.CanvasTexture
  {
    const canvas = document.createElement( "canvas" );
    canvas.width = 2;
    canvas.height = 512;

    const ctx = canvas.getContext( "2d" )!;
    const gradient = ctx.createLinearGradient( 0, 0, 0, canvas.height * 0.22 );
    gradient.addColorStop( 0, "#0067F3" );
    gradient.addColorStop( 1, "#A5E9FF" );
    ctx.fillStyle = gradient;
    ctx.fillRect( 0, 0, canvas.width, canvas.height );

    const texture = new THREE.CanvasTexture( canvas );
    texture.colorSpace = THREE.SRGBColorSpace;
    texture.minFilter = THREE.LinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.needsUpdate = true;
    return texture;
  }

  static update( dt: number ): void
  {
  }
}
